import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ListBanksResponse } from "../interfaces/list-banks.interface";
import { AuthService } from "../../../../core/service/auth.service";

@Injectable({
  providedIn: 'root'
})
export class ListBanksService {
  private readonly apiUrl = environment.apiUrl;
  http = inject(HttpClient);
  authService = inject(AuthService);
  loadListBanks(): Observable<ListBanksResponse> {
    const token = this.authService.getToken();
    return this.http.get<ListBanksResponse>(`${this.apiUrl}/user/banks`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  }
}
